import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import styled from "@emotion/styled";
import Real from "./Real/Real";
import CompositionProductReal from "./CompositionProducts/Real/Real";
import CartePreview from "./CartePreview/CartePreview";
import { Tabs, Tab } from "react-bootstrap";
import Layout from "views/universal/Layout/Layout";
import { storeOperations, storeSelector } from "state/ducks/store";
import Forecast from "./Forecast/Forecast";
import Loader from "views/universal/Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

/**
 * Onglet ouvert, mémorisé d'un chargement à l'autre.
 *
 * La page est rechargée souvent (retour depuis une fiche BO, F5 après une
 * saisie) et repartait à chaque fois sur « Prévisionnel produit » : on perdait
 * l'onglet sur lequel on travaillait. Stocké dans le navigateur plutôt que dans
 * l'URL — la page vit dans l'iframe du BO, dont l'adresse n'est pas la nôtre.
 */
const TAB_KEY = "moulin.stocks.activeTab";
const TABS_VALIDES = ["forecast", "tweakstock", "tweakstockcomposition", "cartepreview"];

const Stocks = (props) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(() => {
    // Repli si l'onglet mémorisé n'existe plus (masqué ou renommé depuis) :
    // sans ça, l'écran s'ouvrait sur un contenu vide.
    const memorise = window.localStorage.getItem(TAB_KEY);
    return TABS_VALIDES.includes(memorise) ? memorise : "forecast";
  });

  const selectTab = (cle) => {
    if (!cle) return;
    setTab(cle);
    window.localStorage.setItem(TAB_KEY, cle);
  };

  const establishment = useSelector(
    (state) => state.session.establishment,
    shallowEqual
  );

  const productCategories = useSelector((state) => {
    return storeSelector.getProductCategoriesSelector(state);
  });

  const activityTypes = useSelector(
    (state) => state.store.activityTypes,
    shallowEqual
  );

  const compositionProductCategories = useSelector((state) => {
    return storeSelector.getCompositionProductCategoriesSelector(state);
  });

  useEffect(() => {
    dispatch(storeOperations.getProductCategories());
    dispatch(storeOperations.getActivityTypes());
    dispatch(storeOperations.getCompositionProductCategories());
  }, [dispatch]);

  return (
    <Layout location={props.location.search}>
      <Container>
        <Import>
          <a href={`${process.env.REACT_APP_LEMOULIN_BO_URL}/e28XmZh3/flux_tires_pdf_task/list`} target="_blank" rel="noopener noreferrer"> <FontAwesomeIcon icon={faDownload} size="xs" /> Flux Tirés PDF</a>
          <a href={`${process.env.REACT_APP_LEMOULIN_BO_URL}/e28XmZh3/store/deliveroo/`} target="_blank" rel="noopener noreferrer"> <FontAwesomeIcon icon={faDownload} size="xs" /> Donnée Deliveroo - </a>
          <a href={`${process.env.REACT_APP_LEMOULIN_BO_URL}/e28XmZh3/store/ikentoo/`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faDownload} size="xs" /> Donnée Ikentoo</a>
        </Import>
        <Tabs activeKey={tab} onSelect={selectTab} fill >
          <Tab eventKey="forecast" title="Prévisionnel produit">
            {productCategories.data && activityTypes.data ? (
              <Forecast
                establishment={establishment}
                productCategories={productCategories.data}
                activityTypes={activityTypes.data}
              />
            ) : (
              <Loader items={1} />
            )}
          </Tab>
          <Tab eventKey="tweakstock" title="Ajust Stock Produit">
            {productCategories.data ? (
              <>
                <Real
                  establishment={establishment}
                  productCategories={productCategories.data}
                />
              </>
            ) : (
              <Loader items={1} />
            )}
          </Tab>
          <Tab eventKey="tweakstockcomposition" title="Ajust Stock Ingredient">
            {compositionProductCategories.data ? (
              <>
                <CompositionProductReal
                  establishment={establishment}
                  compositionProductCategories={compositionProductCategories.data}
                />
              </>
            ) : (
              <Loader items={1} />
            )}
          </Tab>
          {/* Masqué le 06/08/2026 à la demande de l'équipe. Pour le rétablir :
              décommenter et remettre l'import de ContainerRecovery, plus
              "containerrecovery" dans TABS_VALIDES. */}
          {/* <Tab eventKey="containerrecovery" title="Récup Zéro Déchet">
            <ContainerRecovery establishment={establishment} />
          </Tab> */}
          {/* Aperçu de la carte du tunnel B2C : ce que le client verra pour un
              site / canal / date, et ce qui ne sortira pas — avec la raison.
              Lecture seule, monté seulement quand l'onglet est ouvert
              (`mountOnEnter`) : inutile de charger toute la carte tant qu'on
              travaille sur le prévisionnel. */}
          <Tab eventKey="cartepreview" title="À la carte" mountOnEnter>
            <CartePreview establishment={establishment} />
          </Tab>
          {/* <Tab eventKey="menu" title="A la carte disponible">
            {productCategories.data ? (
              <>
                <ALaCartes
                  establishment={establishment}
                  productCategories={productCategories.data}
                />
              </>
            ) : (
              <Loader items={1} />
            )}
          </Tab> */}
        </Tabs>
      </Container>

    </Layout>
  );
};

const Container = styled.div`
  padding: 1rem;
`;

const Import = styled.div`
  text-align: right;
  & > a, & > button {
    margin-left: 1rem;
  }
`;

Stocks.propTypes = {};

Stocks.defaultProps = {};

export default Stocks;
